/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { is } from 'bpmn-js/lib/util/ModelUtil';

import { createBpmnModdle } from './moddle-util';

const DEFAULT_PROCESS_ID = 'NO_PROCESS_ID';

/**
 * Get the process ID of the first (executable) process in a BPMN definitions object.
 *
 * @param {Object} definitions
 * @param {string} [defaultProcessId=DEFAULT_PROCESS_ID]
 *
 * @returns {string}
 */
export function getProcessId(definitions, defaultProcessId = DEFAULT_PROCESS_ID) {
  const rootElements = definitions.get('rootElements');

  const processes = rootElements.filter((element) => is(element, 'bpmn:Process'));

  const executableProcess = processes.find((process) => process.get('isExecutable'));

  if (executableProcess) {
    return executableProcess.get('id');
  }

  if (processes.length > 0) {
    return processes[0].get('id');
  }

  return defaultProcessId;
}

export async function getProcessIdFromXML(xml, defaultProcessId = DEFAULT_PROCESS_ID) {
  try {
    const bpmnModdle = createBpmnModdle();

    const { rootElement } = await bpmnModdle.fromXML(xml);

    return getProcessId(rootElement, defaultProcessId);
  } catch (err) {
    console.error(err);

    return defaultProcessId;
  }
}
